import { render, staticRenderFns } from "./NottinghamResultPanel.vue?vue&type=template&id=0f1c9b46&scoped=true"
import script from "./NottinghamResultPanel.vue?vue&type=script&lang=js"
export * from "./NottinghamResultPanel.vue?vue&type=script&lang=js"
import style0 from "./NottinghamResultPanel.vue?vue&type=style&index=0&id=0f1c9b46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c9b46",
  null
  
)

export default component.exports